import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { checkInAPI, checkOutAPI } from "../../api/attendance";

const Attendance = () => {
  const [checkedIn, setCheckedIn] = useState(false);
  const [checkInTime, setCheckInTime] = useState(null);
  const [pendingCheckout, setPendingCheckout] = useState(false);
  const [time, setTime] = useState(new Date());
  const [status, setStatus] = useState(""); // Present / Absent
  const [showModal, setShowModal] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(""); // Half Day or Absent


  const [formData, setFormData] = useState({
    employeeId: "121",
    employeeName: "Ram",
    department: "",
    location: "",
    remarks: "",
  });

  // Live clock
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ================= Check-In =================
  const handleCheckIn = async () => {
    if (!formData.department || !formData.location) {
      toast.error("Please fill Department & Location");
      return;
    }

    try {
      const res = await checkInAPI({
        department: formData.department,
        location: formData.location,
      });

      toast.success(res.data.message);
      setCheckedIn(true);
      setCheckInTime(new Date()); // freeze check-in time

    } catch (error) {
      const msg = error.response?.data?.message;
      if (msg === "Already checked in") {
        toast.info("You have already checked in today ✅");
        setCheckedIn(true);
        setCheckInTime(new Date()); // optional: fetch exact time from backend
      } else {
        toast.error(msg || "Check-in failed");
      }
    }
  };

 const handleCheckOut = () => {
  if (!checkInTime) {
    toast.error("You need to check in first!");
    return;
  }

  const currentTime = new Date();
  const diffHours = (currentTime - checkInTime) / (1000 * 60 * 60);

  let statusToCheck = "";

  if (diffHours >= 9) {
    setStatus("Present ✅");
    sendCheckout("Present", currentTime);
  } else if (diffHours >= 4 && diffHours < 9) {
    statusToCheck = "Half Day ❌";
  } else if (diffHours < 4) {
    statusToCheck = "Absent ❌";
  }

  if (statusToCheck) {
    setPendingStatus(statusToCheck);
    setShowModal(true); // show popup
  }
};
const sendCheckout = async (finalStatus, checkoutTime) => {
  try {
    await checkOutAPI({
      remarks: formData.remarks,
      checkInTime,
      checkOutTime: checkoutTime,
      status:
        finalStatus.includes("Present")
          ? "Present"
          : finalStatus.includes("Half Day")
          ? "Half Day"
          : "Absent",
    });
    setStatus(finalStatus);
    toast.success("Check-out success ✅");
  } catch (error) {
    toast.error(error.response?.data?.message || "Check-out failed");
  }
};


  


  return (
    <>
    <div className="container-admin">
      <div className="attendance-header gap-4">
        <h2>Employee Attendance</h2>
        <span className="live-time">{time.toLocaleTimeString()}</span>
      </div>

      <div className="attendance-cards">
        <div className="attendance-card checkin">
          <h4>Check In</h4>

          <input
            type="text"
            value={time.toLocaleDateString()}
            className="input-field"
            readOnly
          />
          <input
            type="text"
            value={checkInTime ? checkInTime.toLocaleTimeString() : time.toLocaleTimeString()}
            className="input-field"
            readOnly
          />

          <input
            type="text"
            name="department"
            placeholder="Department"
            className="input-field"
            value={formData.department}
            onChange={handleChange}
          />
          <input
            type="text"
            name="location"
            placeholder="Location"
            className="input-field"
            value={formData.location}
            onChange={handleChange}
          />

          <button
            className="btn checkin-btn"
            onClick={handleCheckIn}
            disabled={checkedIn}
          >
            {checkedIn ? "Checked In ✅" : "Check In"}
          </button>
        </div>

        {/* ================= Check-Out Card ================= */}
        <div className="attendance-card checkout">
          <h4>Check Out</h4>

          <p className="auto-time">Date: {time.toLocaleDateString()}</p>
          <p className="auto-time">
            Time: {time.toLocaleTimeString()}
          </p>

          <textarea
            name="remarks"
            placeholder="Remarks"
            className="textarea-field"
            value={formData.remarks}
            onChange={handleChange}
          />

          <button
            className="btn checkout-btn"
            onClick={handleCheckOut}
            disabled={!checkedIn}
          >
            Check Out
          </button>

          {status && (
            <div className="status">
              <p>Status: {status}</p>
            </div>
          )}
        </div>
      </div>
    </div>
    {showModal && (
  <div className="modal-overlay">
    <div className="modal-content1">
      <h3>Attention!</h3>
      <p>
        You have worked less than required hours. This will be marked as <strong>{pendingStatus}</strong>.
      </p>
      <div className="modal-buttons gap-5">
        <button
          className="btn confirm-btn"
          onClick={() => {
            setShowModal(false);
            sendCheckout(pendingStatus, new Date());
          }}
        >
          Proceed
        </button>
        <button
          className="btn cancel-btn"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    </>
    
  );
};

export default Attendance;
